import { X } from 'lucide-react';
import { Button } from './ui/button';

export function FeatureDetailModal({ isOpen, onClose, feature }) {
    if (!isOpen || !feature) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="relative w-full max-w-md bg-white rounded-[2.5rem] p-8 shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden">
                {/* Background Decor */}
                <div className="absolute -top-24 -right-24 w-48 h-48 bg-primary/5 rounded-full blur-3xl" />
                <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-secondary/5 rounded-full blur-3xl" />

                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 p-2 hover:bg-surface rounded-full transition-colors z-10"
                >
                    <X className="w-5 h-5 text-muted-foreground" />
                </button>

                <div className="relative z-10">
                    <div className="text-center mb-8">
                        <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mx-auto mb-6 transform rotate-3 hover:rotate-0 transition-transform duration-300 shadow-sm border border-primary/20">
                            {feature.icon && <feature.icon className="w-10 h-10 text-primary" />}
                        </div>
                        <h2 className="font-heading text-3xl text-secondary mb-3 tracking-tight">{feature.label}</h2>
                        <div className="h-1 w-12 bg-primary/30 mx-auto rounded-full mb-6" />
                        <p className="text-muted-foreground font-body text-base leading-relaxed px-2">
                            {feature.detail}
                        </p>
                    </div>

                    <div className="space-y-4">
                        <div className="p-5 bg-surface/50 rounded-2xl border border-gray-100 flex items-start gap-4">
                            <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-sm border border-gray-50">
                                <span className="text-primary text-lg font-bold">!</span>
                            </div>
                            <div className="space-y-1">
                                <p className="text-sm font-semibold text-secondary">Why this matters?</p>
                                <p className="text-xs text-muted-foreground leading-relaxed">
                                    We prioritize customer satisfaction and transparency for every purchase on our platform.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-8">
                        <Button
                            onClick={onClose}
                            className="w-full h-14 rounded-full bg-secondary hover:bg-secondary/90 text-white font-body font-semibold text-lg shadow-lg shadow-secondary/10 transform active:scale-95 transition-all"
                        >
                            Got it, thanks!
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
